import React from 'react'
import PropTypes from 'prop-types'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import InputRow from '../elements/InputRow'
import FancySelectRow from '../elements/FancySelectRow'
import TermsAndConditionsCheckbox from '../components/TermsAndConditionsCheckbox'
import TermsOfUseCheckbox from '../components/TermsOfUseCheckbox'
import { SERVICE_VOIP, VOIP_PAYG } from '../constants'
import VoipUnlimited from '../components/VoipUnlimited'
import VoipPayg from '../components/VoipPayg'
import ComparePlans from '../components/ComparePlans/ComparePlans'

const options = {
    postUrl: '/api/postOrderVoip',
    success: 'Success! Your VoIP service order is complete.'
}
const state = {
    type: 'new-order', // default new order
    isTransfer: false, // default not transfer
    planId: '',
    planObj: {}, // For GA
    address: '',
    phoneToTransfer: '',
    currentAccountNo: '',
    referrerCode: '',
    termsOfUse: false,
    termsAndConditions: false
}

class VoipOrderForm extends React.Component {
    componentDidMount () {
        // Set form type transfer|new-order
        this.props.setDynamicValues({
            type: this.props.type,
            isTransfer: this.props.isTransfer ? this.props.isTransfer : false
        })
    }

    handleChangePlan (id) {
	    let planObj = {}
	    this.props.plans.forEach((item, key) => {
	        if (item.id === id) {
	            planObj = item
            }
        })

        this.props.setDynamicValues({
            planId: id,
            planObj: planObj // For GA
        })
    }

    isUnlimited (monthlyFee) {
        return parseFloat(monthlyFee) > 0
    }

    mapExistingPlanFields () {
        return {
            title: 'N/A',
            price: 0,
            html: '',
            features: []
        }
    }

    mapApiPlanFields () {
        const plans = []

        this.props.plans.forEach(plan => {
            plans.push({
                id: plan.id,
                title: plan.description,
                price: this.isUnlimited(plan.monthly_price) ? plan.monthly_price : VOIP_PAYG,
                html: this.isUnlimited(plan.monthly_price) ? <VoipUnlimited /> : <VoipPayg />,
                features: this.props.includes ? [this.props.includes] : []
            })
        })

        return plans
    }

    render () {
        return (
            <form onSubmit={this.props.handleSubmit} onKeyDown={this.props.handleKeyDown}>
                <h2 className='text-center'>Your service details</h2>
                {this.props.isTransfer
                    ? <InputRow
                            label='Phone number'
                            name='phoneToTransfer'
                            value={this.props.values.phoneToTransfer}
                            errors={this.props.errors}
                            handleChange={this.props.handleInputChange}
                            placeholder='Phone number to be transferred incl. area code'
                    />
                    : ''}
                <FancySelectRow
                    label='Select address'
                    name='address'
                    value={this.props.values.address}
                    errors={this.props.errors}
                    options={this.props.addresses}
                    handleChange={this.props.setDynamicValues}
                />
                {this.props.isTransfer
                    ? <InputRow
                            label='Current account number'
                            name='currentAccountNo'
                            value={this.props.values.currentAccountNo}
                            errors={this.props.errors}
                            handleChange={this.props.handleInputChange}
                            placeholder='Account number with your current provider'
                    />
                    : ''}

                <h2 className='text-center mt-5'>Choose your call costs</h2>
                <ComparePlans
                    type={SERVICE_VOIP}
                    plans={this.mapApiPlanFields()}
                    existingPlan={this.mapExistingPlanFields()}
                    handleSelect={this.handleChangePlan.bind(this)}
                    selectedPlanId={parseInt(this.props.values.planId)}
                />

                <div className='mb-3' />
                <TermsOfUseCheckbox
                    errors={this.props.errors}
                    value={this.props.values.termsOfUse}
                    handleClick={value => this.props.setDynamicValues({ termsOfUse: value })}
                    cisUrl='https://files.exetel.com.au/cis/voip/CIS_Home_Phone.pdf'
                    termsUrl='https://www.exetel.com.au/broadband/nbn/terms'
                />
                <br />
                <TermsAndConditionsCheckbox
                    errors={this.props.errors}
                    value={this.props.values.termsAndConditions}
                    handleClick={value => this.props.setDynamicValues({ termsAndConditions: value })}
                    type={SERVICE_VOIP}
                />
                <br />

                {this.props.children}

                <div className='mt-4 row'>
                    <div className='col-12 col-md-6 text-center text-md-left my-2'>
                        <Button title='Place Order' action={this.props.handleSubmit} />
                    </div>
                    <div className='col-12 col-md-6 text-center text-md-right my-2'>
                        <input placeholder='Referrer Code' name='referrerCode' value={this.props.values.referrerCode} onChange={this.props.handleInputChange} />
                    </div>
                </div>
            </form>
        )
    }
}

VoipOrderForm.propTypes = {
    type: PropTypes.oneOf(['transfer', 'new-order']).isRequired,
    isTransfer: PropTypes.bool.isRequired,
    addresses: PropTypes.array.isRequired,
    plans: PropTypes.array.isRequired,
    includes: PropTypes.string
}

export default FormHOC(VoipOrderForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/VoipOrderForm.js